var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-container",on:{"click":_vm.onChange}},[_c('span',{staticClass:"checkbox-title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"widget_checkbox",attrs:{"type":"checkbox"}},[_c('span',{staticClass:"checkbox-checkmark",class:{ active: _vm.value }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }